/**
 * @file サインアウトしたら学習系の画像キャッシュを空にする。
 *
 * @what: 認証状態を購読し、ユーザーが null になった時点で pageImageCache (紙面の object URL) と
 *   useSourceCover の先頭ページの覚えを revoke して捨て、画面をまたいで使い回す一覧の覚え
 *   (sharedFetchCache。資料の一覧・学びメモ) も空にする。
 * @why: 画像キャッシュはモジュールスコープなので、放っておくとサインアウト後も家族の紙面が
 *   メモリに残る。ゼロ知識原則に合わせ、セッションが切れたら持たない (ai-review #628)。
 * @failure: 二重呼び出しは何もしない (購読は 1 本だけ)。
 */

import { subscribeAuth } from "@/shared/auth/firebaseAuth";
import { resetSourceCoverCache } from "../hooks/useSourceCover";
import { resetPageImageCache } from "./pageImageCache";
import { resetSharedFetchCache } from "./sharedFetchCache";

let installed = false;

/** アプリ起動時に 1 回呼ぶ。サインアウトで学習系の画像キャッシュを空にする購読を張る。 */
export function installStudyImageCacheReset(): void {
  if (installed) return;
  installed = true;
  subscribeAuth((user) => {
    if (!user) {
      resetPageImageCache();
      resetSourceCoverCache();
      resetSharedFetchCache();
    }
  });
}

/** テスト用。購読フラグを戻す (購読自体は張り直す前提)。 */
export function __resetInstalledForTest(): void {
  installed = false;
}
